import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Legal.css';

export default function Privacy() {
  const navigate = useNavigate();
  return (
    <div className="legal-page">
      <div className="legal-content animate-fade-in">
        <button className="legal-back-link" onClick={() => navigate(-1)}>← Back</button>
        <h1 className="legal-title">Privacy Policy</h1>
        <div className="legal-updated">Last Updated: April 2026</div>
        <div className="legal-text">
          <h2>1. Introduction</h2>
          <p>Welcome to Fenscope. We are committed to protecting your personal information and your right to privacy.</p>

          <h2>2. Information We Collect</h2>
          <p>We only collect the information necessary to provide our scope evaluation services. This includes:</p>
          <ul>
            <li>Basic account information (email, name) when you sign up using Google OAuth.</li>
            <li>Documents, notes, and text you provide strictly for the purpose of scope evaluation.</li>
          </ul>

          <h2>3. How We Use Data</h2>
          <p>Your uploaded contracts and client requests are processed securely to evaluate scope. We process your data via strictly-controlled APIs. We do not use your private client data to publicly train our models, nor do we sell your data to any third parties.</p>

          <h2>4. Data Retention &amp; Deletion</h2>
          <p>You have full control over your data. Upon requesting account deletion, all associated projects, extracted scope data, evaluations, and personal information are permanently removed from our active systems.</p>

          <h2>5. Contact Us</h2>
          <p>If you have any questions or concerns about this policy or our practices, you may contact us at <a href="mailto:support@fenscope.com" style={{ color: 'var(--accent)' }}>support@fenscope.com</a>.</p>
        </div>
      </div>
    </div>
  );
}
